import { IGroupedComboBoxItem } from '../GroupedComboBox/GroupedComboBox.types.shared';

/**
 * The comparer function which can be used to sort sub items in an L2 menu.
 * It sorts items based on the `order` property if it is defined. Otherwise, it sorts by `text`
 */
export function sortMenuItemByOrder(a: IGroupedComboBoxItem, b: IGroupedComboBoxItem): number {
    const orderA = a.order;
    const orderB = b.order;

    // if neither order is set, sort by the 'text' prop
    if (orderA === undefined && orderB == undefined) {
        return a.text.localeCompare(b.text);
    }

    if (orderA === undefined || orderB === undefined) {
        return orderA === undefined ? -1 : 1;
    }

    return orderA - orderB;
}
